export default __webpack_public_path__ + "static/media/screen4.9cb80fed.png";